import { Injectable } from '@angular/core';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { Ng2DeviceService } from 'ng2-device-detector';
@Injectable()
export class forgotPasswordService {
  constructor(private utilserv: utilityService, private deviceService: Ng2DeviceService, private geoloc: geolocation) {}

  //Method for sending mail for password reset
  getForgotPassEnvelope(emailId: string) {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    let envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                <s:Header>
                  <a:Action s:mustUnderstand="1">http://ForgotPasswordSoapService/IMicroServiceForgotPassword/ForgotPassword</a:Action>
                  <a:MessageID>urn:uuid:09658647-47e3-457f-a643-97d60f5cd3dd</a:MessageID>
                  <a:ReplyTo>
                    <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                  </a:ReplyTo>
                </s:Header>
                <s:Body>
                  <ForgotPasswordRequest xmlns="http://ForgotPasswordSoapService/">
                  <CustomerEmail>${emailId}</CustomerEmail>
                    <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                      <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                      <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                      <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                      <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                      <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                      <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                      <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                      <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                      <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                      <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                      <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                    </DeviceDetails>
                  <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                  </ForgotPasswordRequest>
                </s:Body>
              </s:Envelope>
              `;
    return envelope;
  }
  ForgotPassword(email) {
    return this.utilserv.soapPostwithoutAction(this.getForgotPassEnvelope(email), AppSettings.forgot_pass_soap_url);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/user.forgotpassword.service.ts